import { feathers } from '@/feathers-client';
import { buildQueryParams } from '@/Core/utilities/queryParams';

const initialState = {
  shortCodes: [],
  totalShortCodes: 0,
  isLoading: false,
  error: null,
};

/**
 * display better AJV error messages from the backend
 * error.message just displays "Invalid Parameters for ..."
 */
const showErrors = error => {
  const { message, errors } = error;
  if (errors && Array.isArray(errors)) {
    return `${message}: ${errors.join('\n')}`;
  }
  return message;
};

export default {
  namespaced: true,
  state: { ...initialState },

  mutations: {
    setIsLoading(state, bool) {
      state.isLoading = bool;
    },
    setError(state, error) {
      state.error = error;
    },
    setShortCodes(state, shortCodes) {
      state.shortCodes = shortCodes;
    },
    setTotalShortCodes(state, total) {
      state.totalShortCodes = total;
    },
  },

  actions: {
    // SHORT CODE ACTIONS
    async getShortCodes({ commit }, { page, descending, sortByField, limit }) {
      commit('setIsLoading', true);

      try {
        const query = buildQueryParams({ page, descending, sortByField, limit });
        const response = await feathers.service('short-codes').find({ query });
        commit('setShortCodes', response.data);
        commit('setTotalShortCodes', response.total);
      } catch (err) {
        commit('setError', err.message);
      }

      commit('setIsLoading', false);
    },
    async deleteShortCode({ commit, dispatch }, { shortCodeId, queryParams }) {
      try {
        await feathers.service('short-codes').remove(shortCodeId);
        dispatch('getShortCodes', queryParams);
      } catch (err) {
        commit('setError', err.message);
      }
    },
    async createShortCode({ commit, dispatch }, { shortCodeParams, queryParams }) {
      commit('setError', null);
      try {
        await feathers.service('short-codes').create(shortCodeParams);
        dispatch('getShortCodes', queryParams);
      } catch (err) {
        commit('setError', showErrors(err));
      }
    },
    async editShortCode({ commit, dispatch }, { shortCodeParams, queryParams }) {
      commit('setError', null);
      try {
        const shortCodeId = shortCodeParams.id;
        delete shortCodeParams.id;
        await feathers.service('short-codes').patch(shortCodeId, shortCodeParams);

        dispatch('getShortCodes', queryParams);
      } catch (err) {
        commit('setError', showErrors(err));
      }
    },

    // SHORTENED URL ACTIONS
    async createShortenedUrl({ commit, dispatch }, { shortCodeId, queryParams }) {
      commit('setError', null);
      try {
        await feathers.service(`short-codes/${shortCodeId}/shortened-url`).create({});
        dispatch('getShortCodes', queryParams);
      } catch (err) {
        commit('setError', err.message);
      }
    },
    async deleteShortenedUrl({ commit, dispatch }, { shortCodeId, shortenedUrlId, queryParams }) {
      commit('setError', null);
      try {
        await feathers.service(`short-codes/${shortCodeId}/shortened-url`).remove(shortenedUrlId);
        dispatch('getShortCodes', queryParams);
      } catch (err) {
        commit('setError', err.message);
      }
    },
  },
};
